var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessStepper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#5ABD2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7038 9.15254C21.7824 9.21217 21.8484 9.2867 21.8981 9.37187C21.9478 9.45704 21.9802 9.55117 21.9935 9.64889C22.0068 9.7466 22.0007 9.84598 21.9755 9.94132C21.9503 10.0367 21.9066 10.1261 21.8468 10.2045L13.8468 20.7045C13.782 20.7896 13.6996 20.8598 13.6054 20.9104C13.5111 20.961 13.4071 20.9909 13.3004 20.998C13.1936 21.0051 13.0866 20.9892 12.9865 20.9516C12.8863 20.9139 12.7954 20.8552 12.7198 20.7795L8.21985 16.2795C8.08737 16.1374 8.01524 15.9493 8.01867 15.755C8.0221 15.5607 8.10081 15.3753 8.23822 15.2379C8.37564 15.1005 8.56102 15.0218 8.75532 15.0184C8.94963 15.0149 9.13767 15.0871 9.27985 15.2195L13.1738 19.1125L20.6538 9.29555C20.7742 9.1375 20.9524 9.03367 21.1493 9.00686C21.3461 8.98005 21.5456 9.03245 21.7038 9.15254Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStepper);
export default __webpack_public_path__ + "static/media/success_stepper.8229babbe9cc14b7f42d952df6770083.svg";
export { ForwardRef as ReactComponent };